import {injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {SubtenantArticlesAccessModel} from './SubtenantArticlesAccess.model';

@injectable()
export class SubtenantArticlesAccessModelFactory
  implements
    BaseDomainFactory<
      SubtenantArticlesAccessModel,
      SubtenantArticlesAccessModel.Props
    >
{
  create(
    props: SubtenantArticlesAccessModel.Props,
  ): SubtenantArticlesAccessModel {
    return new SubtenantArticlesAccessModel(props);
  }

  createEmpty(): SubtenantArticlesAccessModel {
    return new SubtenantArticlesAccessModel({
      hasAccess: false,
      hasPremiumAccess: false,
      id: '',
    });
  }
}
